import {Component, Input, OnInit} from '@angular/core';
import {RankingService} from "../../services/ranking.service";
import {MilestonesService} from "../../services/milestones.service";
import {TrophyService} from "../../services/trophy.service";
import {OrganizationExperienceService} from "../../services/organization-experience.service";
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {RankingListItem} from "../../interfaces/ranking-list-item";
import {ChartComponentData} from "../../interfaces/chart-component-data";
import {Milestone} from "../../interfaces/milestone";
import {TrophyRepositoryService} from "../../services/trophy-repository.service";
import {OrganizationTrophyData} from "../../interfaces/organization-trophy-data";
import {OrganizationTrophyItem} from "../../interfaces/organization-trophy-item";
import {TrophyData} from "../../interfaces/trophy-data";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {getActiveClassId} from "../../store/selectors/teacher.selector";
import {take} from "rxjs";
import {SchoolClassDataService} from "../../services/school-class-data.service";
import {SchoolClassData} from "../../interfaces/school-class-data";
import {OverlayService} from "../../overlay/overlay.service";
import {MilestonesProgressOverlayComponent} from "../milestones-progress-overlay/milestones-progress-overlay.component";
import {
  MilestonesProgressOverlayFooterComponent
} from "../milestones-progress-overlay/milestones-progress-overlay-footer/milestones-progress-overlay-footer.component";
import {ChartItemData} from "../../interfaces/chart-item-data";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {DataService} from "../../services/data.service";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-class-main-statistics-block',
  templateUrl: './class-main-statistics-block.component.html',
  styleUrls: ['./class-main-statistics-block.component.scss']
})
export class ClassMainStatisticsBlockComponent implements OnInit {
  // @Input('class-code') set setOrganizationId(val: number) {
  //   // this.organizationId = val;
  //
  //   // this.loadAll();
  // }

  organizationId!: number;
  schoolClassData?: SchoolClassData;

  private milestones = this.milestonesService.getMilestones();

  rankingData?: RankingListItem;

  achievedMilestones: Milestone[] = [];
  milestonesLabelString = "";
  currentExperience = -1;
  maxMilestoneIconsNumberToShow = 4;


  headlineComponentData: Partial<DashboardBoxesHeadData> = {
    title: "Berufsreise Gewinnspiel",
    titleIcon: "trophy",
    color: "cyan",
    hint: "Noch 58 Tage"
  }

  chartData?: ChartComponentData;
  currentTrophyProgress = 0;
  trophyData?: OrganizationTrophyData;
  trophyRepositoryData: TrophyData[] = [];
  completedTrophiesData: TrophyData[] = [];

  totalTrophyNumber = 0;
  completedTrophyItems: OrganizationTrophyItem[] = [];
  maxTrophyIconsNumberToShow = 4;

  trophyIdNameMap = new Map<number, string>();
  playTimeString = "0 Std. 0 Min.";

  constructor(private rankingService: RankingService,
              private experienceService: OrganizationExperienceService,
              private trophyService: TrophyService,
              private trophyRepositoryService: TrophyRepositoryService,
              private milestonesService: MilestonesService,
              private store: Store<AppState>,
              private overlay: OverlayService,
              private data: DataService
  ) {
  }

  ngOnInit() {
    this.store.select(getActiveClassId()).pipe(untilDestroyed(this)).subscribe((classId) => {
      this.organizationId = classId;

      this.data.getSchoolClassById(this.organizationId).pipe(untilDestroyed(this)).subscribe((schoolClassData) => {
        this.schoolClassData = schoolClassData;
        this.loadAll();
      })
    })
  }

  loadAll(): void {
    if(!this.schoolClassData || !this.schoolClassData.classCode) return;

    this.rankingService.getRankingExcerpt(this.organizationId).then((excerpt) => {
      // console.log('ranking-excerpt',excerpt);
      const currentClassRanking = excerpt.ranking.filter((el) => el.schoolClassData.id === this.schoolClassData?.id);

      if(currentClassRanking.length) {
        this.rankingData = currentClassRanking[0];
      }
    });

    this.data.getSchoolClassPoints(this.schoolClassData.classCode).pipe(take(1)).subscribe((experience) => {
      if(experience) {
        this.currentExperience = experience;
      }
      this.achievedMilestones = this.milestonesService.getMilestones().filter((el) => el.points <= experience);

      this.milestonesLabelString = `${this.achievedMilestones.length} von ${this.milestonesService.getMilestones().length} Meilensteine`;
    });

    this.data.getSchoolClassTimePlayed(this.schoolClassData.classCode).pipe(take(1)).subscribe((timePlayed) => {
      let hours = Math.floor(timePlayed / 60);
      let minutes = Math.floor(timePlayed % 60);
      this.playTimeString = `${hours} Std. ${minutes} Min.`;
    });

    this.experienceService.loadSchoolClassLatestExperience(this.schoolClassData.classCode, false).then((experience) => {
      // this.currentExperience = experience;
      // console.log(experience);
      // console.warn("ABOVE");
      // this.achievedMilestones = this.milestonesService.getMilestones().filter((el) => el.points <= experience);
      //
      // this.milestonesLabelString = `${this.achievedMilestones.length} von ${this.milestonesService.getMilestones().length} Meilensteine`;
    });

    this.experienceService.loadSchoolClassHistoryExperience(this.schoolClassData.classCode).then((experienceHistory) => {
      const items = experienceHistory.reverse(); // TODO: uncomment
      // const items = [...experienceHistory, ...experienceHistory, ...experienceHistory, ...experienceHistory, ...experienceHistory, ...experienceHistory, ...experienceHistory].reverse(); // TODO remove
      let chartItems: ChartItemData[] = [];
      for(let i = 1; i < items.length; i++) {
        chartItems.push({
          label: "",
          value: items[i].points - items[i - 1].points
        })
      }

      if(chartItems.length > 1) {
        this.chartData = {
          type: "line-preview",
          data: {
            datasets: [
              {
                label: "",
                items: chartItems,
                color: "#0ff0ff"
              }
            ]
          }
        }
      } else {
        console.warn("Experience chart has less than 3 records");
      }
    });


    this.trophyService.loadClassTrophies(this.organizationId).then((trophies) => {

      this.trophyData = trophies;

      this.completedTrophyItems = this.trophyData.items.filter((el) => el.percentValue === 100);
      this.totalTrophyNumber = this.trophyData.items.length;

      this.currentTrophyProgress = Math.round(this.completedTrophyItems.length / this.totalTrophyNumber * 100);

      this.completedTrophyItems.forEach((el) => {
        this.trophyRepositoryService.getTrophyById(el.trophyId).then((trophy) => {
          this.trophyRepositoryData.push(trophy);
          this.completedTrophiesData = [...this.completedTrophiesData, trophy];
        })
      });
    });


  }

  openRankingList() {
    this.rankingService.openRankingOverlay();
  }

  getTrophyIcon(trophy: TrophyData): string {
    return this.trophyRepositoryService.getTrophyIcon(trophy);
  }

  getTrophyNameById(trophyId: number) {
    const trophyData = this.trophyRepositoryData.filter((el) => el.id === trophyId);

    if(trophyData.length) {
      return trophyData[0].name;
    }
    return "";
  }

  openMilestonesOverlay() {
    this.overlay.openWindowOverlay({
      title: "Milestones",
      theme: "game",
      componentMain: {
        component: MilestonesProgressOverlayComponent,
        data: {
          experience: this.currentExperience
        }
      },
      componentFooter: {
        component: MilestonesProgressOverlayFooterComponent
      }
    })
  }

  showTrophiesOverlay() {
    this.trophyService.openTrophiesOverlay(this.organizationId);
  }
}
